/**
 * Legal documents in Arabic. Mirrors `../en/legal.js`: same paths, section ids
 * and block shapes. The Arabic version prevails if the two differ.
 */
export const LEGAL_META = {
  eyebrow: 'قانوني',
  updated: 'الإصدار 1.0 · ساري من 4 نوفمبر 2026',
  draft: null,
  tocTitle: 'في هذه الصفحة',
}

export const LEGAL_DOCS = [
  {
    path: '/privacy',
    title: 'سياسة الخصوصية',
    intro:
      'كيف نجمع البيانات الشخصية ونستخدمها ونحميها عند استخدامك MeetNPlan. عند اختلاف النسختين العربية والإنجليزية، تسود النسخة العربية.',
    sections: [
      {
        id: 'who-we-are',
        title: 'من نحن',
        body: [
          'تُشغّل MeetNPlan شركة Code LTD، سجل تجاري رقم 7025667853، والرقم الضريبي 311024246500003، وعنوانها طريق الأمير سلطان بن عبدالعزيز، حي السليمانية، الرياض 12232، المملكة العربية السعودية، والعنوان الوطني المختصر RHSB3135 ("نحن"). لأي أمر يتعلق ببياناتك الشخصية، راسلنا على privacy@meetnplan.co. ولغير ذلك، راسلنا على hello@meetnplan.co أو اتصل على 800 100 0018.',
        ],
      },
      {
        id: 'who-this-covers-and-our-role',
        title: 'من تشملهم هذه السياسة، وما دورنا',
        body: [
          'تشمل هذه السياسة زوار موقع meetnplan.co، ومستخدمي تطبيق MeetNPlan، والضيوف المدعوين إلى الاجتماعات، والزوار الذين يسجلون دخولهم عند استقبال إحدى الشركات.',
          {
            list: [
              'شركتك هي التي تقرر. تحدد الشركة التي تستخدم MeetNPlan سبب استخدام سجلات موظفيها وضيوفها وزوارها وطريقة استخدامها. وهي جهة التحكم في تلك البيانات، ونحن نعالجها وفق تعليماتها. وتسري عليك كذلك سياسة الخصوصية الخاصة بها.',
              'نحن من يقرر. نحن جهة التحكم في الحسابات وتسجيل الدخول، والأمن، والفوترة، والدعم، وموقعنا الإلكتروني، ورسائلنا إلى العملاء.',
            ],
          },
        ],
      },
      {
        id: 'the-data-we-collect',
        title: 'البيانات التي نجمعها',
        body: [
          {
            table: {
              head: ['تخص', 'البيانات', 'مصدرها', 'جهة التحكم'],
              rows: [
                [
                  'أصحاب الحسابات',
                  'الاسم، والبريد الإلكتروني للعمل، والدور، وحالة الحساب، وطريقة الانضمام، وكلمة المرور (تُحفظ في صورة قيمة تجزئة (hash) فقط)، والصورة، وإعدادات اللغة والتاريخ، وخيارات الإشعارات، ورقم الجوال إن أضفته، وحالتك لليوم، وآخر وقت نشاط، وإصدارات الشروط وهذه السياسة التي قبلتها ووقت قبولها، وما إذا وافقت على تلقي أخبار المنتج',
                  'أنت، أو شركتك، أو Google إن سجلت الدخول عبرها',
                  'نحن للدخول والأمن، وشركتك لسجلات موظفيها',
                ],
                [
                  'مستخدمو Google',
                  'الاسم والبريد الإلكتروني والصورة. وإن ربطت تقويم Google: رمز الإذن (يُحفظ مشفرًا)، وأوقات انشغالك، وتفاصيل الاجتماعات التي نضيفها إلى تقويمك',
                  'Google، بإذنك',
                  'نحن',
                ],
                [
                  'الاجتماعات',
                  'العنوان، والتاريخ، والوقت، والقاعة أو الموقع (وموقع جهازك إن ضغطت «استخدم موقعي»)، ورابط الاجتماع الإلكتروني، والحضور، واسم العميل، وسبب الرفض أو الإلغاء إن ذُكر',
                  'الشخص الذي يحجز',
                  'شركتك',
                ],
                [
                  'الضيوف المدعوون',
                  'الاسم، والبريد الإلكتروني، والشركة، ورقم الجوال (ويلزم المضيف إدخاله لاجتماع العميل أو الاجتماع في قاعة)، وعلامة كبار الزوار، وردك على الدعوة، وأي ملاحظة ترسلها بشأن تغيير الموعد',
                  'المضيف الذي دعاك، وأنت',
                  'شركتك',
                ],
                [
                  'الزوار عند الاستقبال',
                  'الاسم، ورقم الجوال، والشركة، والبريد الإلكتروني إن قُدّم، والغرض من الزيارة، والمضيف، ووقتا الدخول والخروج، وتوقيعك عند الدخول والخروج، واسم من يرافقك ورقم جواله',
                  'أنت وفريق الاستقبال',
                  'شركتك',
                ],
                [
                  'الرسائل',
                  'النصوص، والملفات، والرسائل الصوتية، والتفاعلات، وعلامات القراءة',
                  'مستخدمو الرسائل',
                  'شركتك',
                ],
                [
                  'الفوترة',
                  'الباقة، والفواتير (وفيها الاسم النظامي لشركتك ورقمها الضريبي وعنوانها)، والمبالغ، وحالة الدفع. تنتقل بيانات البطاقة وSTC Pay من متصفحك إلى مزود الدفع مباشرة، ولا نحفظها',
                  'مسؤولو شركتك',
                  'نحن',
                ],
                [
                  'الدعم',
                  'ما تخبرنا به في طلب الدعم أو البريد الإلكتروني',
                  'أنت',
                  'نحن',
                ],
                [
                  'البيانات التقنية',
                  'سجلات أمنية لعمليات الدخول والإجراءات. وتحتفظ كل جلسة دخول بعنوان IP ونوع متصفحك إلى أن تنتهي. ويعالج مزودو الاستضافة لدينا عناوين IP، ولا نحتفظ لمنع إساءة الاستخدام إلا بقيمة تجزئة منها',
                  'جهازك',
                  'نحن',
                ],
                [
                  'من يتواصل معنا',
                  'ما تكتبه في بريدك الإلكتروني. يفتح النموذج في موقعنا تطبيق البريد لديك',
                  'أنت',
                  'نحن',
                ],
              ],
            },
          },
          {
            lead: 'ما يلزم تقديمه.',
            text: 'نحتاج إلى اسمك وبريدك الإلكتروني للعمل لإنشاء حساب. ورقم الجوال اختياري ما لم تطلبه شركتك. وإن لم تقدم للشركة بيانات الزائر التي تطلبها، فقد لا تتمكن من تسجيل دخولك.',
          },
          {
            lead: 'البيانات الحساسة.',
            text: 'لا نطلب بيانات صحية أو دينية أو غيرها من البيانات الحساسة، ولا أي بيانات ائتمانية. فنرجو عدم إدخالها في الرسائل أو الملاحظات أو الملفات. ويجب ألا تستخدم فرق الاستقبال MeetNPlan لحفظ نسخ من بطاقات الهوية أو غيرها من الوثائق الرسمية.',
          },
        ],
      },
      {
        id: 'why-we-use-it-and-on-what-legal-basis',
        title: 'لماذا نستخدمها، وبأي مسوغ نظامي',
        body: [
          {
            table: {
              head: ['الغرض', 'المسوغ النظامي'],
              rows: [
                [
                  'تشغيل الخدمة: الحسابات، والحجوزات، والدعوات، والتذكيرات، والاستقبال، والرسائل، ومزامنة التقويم',
                  'إذا قبلت شروطنا، فالمسوغ هو ذلك الاتفاق. وإلا فمصلحتنا المشروعة في توفير الحسابات لجهة عملك. أما الضيوف والزوار فالمسوغ هو ما تعتمد عليه شركتك، وغالبًا مصلحتها المشروعة في إدارة مكتبها بأمان، أو موافقتك',
                ],
                [
                  'حماية الخدمة: منع إساءة الاستخدام، ومطابقة كلمات المرور مع التسريبات المعروفة، وحفظ سجلات الإجراءات المهمة',
                  'مصلحتنا المشروعة في حماية الأشخاص والخدمة',
                ],
                [
                  'الفوترة والسجلات الضريبية والنظامية',
                  'الاتفاق مع العميل، والتزاماتنا النظامية',
                ],
                ['الدعم', 'الاتفاق، أو مصلحتنا المشروعة في مساعدة المستخدمين'],
                [
                  'أخبار المنتج والعروض',
                  'موافقتك المستقلة، بالتأشير على مربع أو من ملفك الشخصي. ويمكنك الإيقاف في أي وقت مجانًا بنقرة واحدة من كل رسالة أو من ملفك الشخصي',
                ],
              ],
            },
          },
          'لا نبيع البيانات الشخصية، ولا نستخدمها في الإعلانات، ولا نستخدمها لأي غرض لا يتفق مع سبب جمعها.',
        ],
      },
      {
        id: 'if-someone-else-gave-us-your-details',
        title: 'إذا زوّدنا شخص آخر ببياناتك',
        body: [
          'يُدخل المضيف بيانات الضيف، ويمكن لزملائك إضافتك إلى اجتماع. وتوضح لك الدعوة من دعاك وما موضوع الاجتماع. وتصلك باسم "المضيف (الشركة) عبر MeetNPlan"، وتذهب الردود إلى المضيف. وعندما تطلب الشركة من الزائر توقيعًا، يوضح النموذج مدة الاحتفاظ بسجله.',
        ],
      },
      {
        id: 'who-can-see-your-data',
        title: 'من يمكنه رؤية بياناتك',
        body: [
          {
            table: {
              head: ['البيانات', 'من يمكنه رؤيتها'],
              rows: [
                [
                  'الاسم، والبريد الإلكتروني، والصورة، والدور، وآخر وقت نشاط، والحالة لليوم، وإعدادات اللغة والتاريخ والإشعارات، وهل تقويم Google مربوط، وطريقة انضمامك ووقته ومن اعتمدك',
                  'الزملاء المعتمدون في شركتك',
                ],
                [
                  'الاجتماعات',
                  'الاجتماع في قاعة: يطّلع الزملاء المعتمدون على عنوانه واسم العميل وأسماء المدعوين وبريدهم الإلكتروني. والاجتماع دون قاعة: المنظم والمدعوون ومسؤولو الشركة ومن يطلب الاجتماع أن يحل محل حجزه. ولا يرى الاستقبال إلا نوعه ووقته، ولا يرى الزملاء إلا أنك مشغول. ويمكن للمدعوين رؤية أسماء بعضهم وردودهم',
                ],
                ['المتقدمون بانتظار الاعتماد', 'مسؤولو الشركة والموارد البشرية'],
                ['رقم جوالك', 'أنت، ومسؤولو الشركة، والموارد البشرية، والاستقبال'],
                [
                  'رقم جوال الضيف',
                  'منظم الاجتماع، والمدعوون إليه، ومسؤولو الشركة، والاستقبال في الاجتماعات التي لها قاعة',
                ],
                [
                  'سجلات الزيارات',
                  'الاستقبال. ويرى المضيف زواره فقط. أما التوقيعات والمرافقون فللاستقبال فقط. ويظهر اسم الزائر وشركته كذلك في إشعارات المضيف، التي يمكن لمسؤولي الشركة ومشغّلينا قراءتها، وفي محادثة الاجتماع أو محادثة الاستقبال الخاصة بالمضيف',
                ],
                [
                  'الرسائل والملفات',
                  'أعضاء تلك المحادثة. أما المحادثات الواردة إلى صندوق فريق، كالموارد البشرية أو الاستقبال، فيطّلع عليها ذلك الفريق',
                ],
                [
                  'موظفونا',
                  'يمكن لعدد محدود من المشغّلين المخوّلين رؤية الحسابات، والحجوزات، وسجل الاجتماعات، والإشعارات، والدعوات، والفواتير، وطلبات الدعم، ونشاط الشركة، لتشغيل الخدمة. ويمكن لمسؤولينا التقنيين الوصول إلى البيانات المخزنة عند الحاجة إلى ذلك للدعم أو الأمن أو لمتطلبات النظام. وهذا الوصول محدود، ولا يُستخدم لأي غرض آخر',
                ],
              ],
            },
          },
        ],
      },
      {
        id: 'who-we-share-it-with',
        title: 'مع من نشاركها',
        body: [
          'نستعين بهؤلاء المزودين لتشغيل الخدمة، وهم يعالجون البيانات لمصلحتنا. كما نفصح عن البيانات إذا أوجب ذلك النظام أو طلبته جهة مختصة.',
          {
            table: {
              head: ['المزود', 'ما يتلقاه', 'السبب', 'الموقع'],
              rows: [
                [
                  'Supabase',
                  'جميع بيانات الخدمة',
                  'قاعدة البيانات، وتسجيل الدخول، وتخزين الملفات، ووظائف الخادم',
                  'قاعدة البيانات والملفات في فرانكفورت، ألمانيا. وقد تعمل وظائف الخادم في أقرب منطقة لدى Supabase إلى الطلب',
                ],
                [
                  'Cloudflare',
                  'جميع حركة الويب، بما فيها عناوين IP',
                  'إيصال المواقع، وفحص البرامج الآلية، والأمن، وتقارير أخطاء الشبكة',
                  'شبكة عالمية',
                ],
                [
                  'Resend',
                  'مستلم الرسالة، وموضوعها، ومحتواها، ومرفقاتها',
                  'إرسال البريد الإلكتروني',
                  'طوكيو، اليابان. وResend شركة أمريكية',
                ],
                [
                  'Google',
                  'بيانات تسجيل الدخول. وإن ربطت التقويم: عنوان الاجتماع، واسم العميل، والقاعة، وبريد الزملاء، ووصف يذكر المنظم والزملاء المدعوين مع عدد الضيوف الخارجيين فقط، ولا يُرسل بريد الضيوف الخارجيين إلى Google، ولا أسماؤهم إلا بوصفها اسم العميل إذا لم يذكر المضيف شركة. وعنوان IP عند تحميل الخطوط. والبريد المرسل إلى عناويننا',
                  'تسجيل الدخول، ومزامنة التقويم، والخطوط، وبريدنا',
                  'عالمي، في مراكز بيانات Google',
                ],
                [
                  'Moyasar',
                  'بيانات البطاقة أو STC Pay، والمبلغ، ومرجع الشركة',
                  'تحصيل المدفوعات',
                  'المملكة العربية السعودية',
                ],
                [
                  'Have I Been Pwned',
                  'أول خمسة أحرف من قيمة تجزئة كلمة المرور الجديدة، وليس كلمة المرور نفسها',
                  'المطابقة مع التسريبات المعروفة',
                  'عالمي، عبر شبكة Cloudflare',
                ],
              ],
            },
          },
        ],
      },
      {
        id: 'data-outside-the-kingdom',
        title: 'البيانات خارج المملكة',
        body: [
          'تُخزَّن بياناتك في ألمانيا، ويعمل بعض المزودين المذكورين أعلاه في دول أخرى. ولا ننقل البيانات إلا للأغراض الواردة في هذه السياسة، وإلى المزودين المذكورين أعلاه فقط. ويمكنك طلب تفاصيل هذا النقل منا.',
        ],
      },
      {
        id: 'how-long-we-keep-it',
        title: 'مدة الاحتفاظ بها',
        body: [
          {
            table: {
              head: ['البيانات', 'المدة'],
              rows: [
                [
                  'سجلات الزيارات، والتوقيعات، وأرقام جوال الضيوف في الاجتماعات، ورسائل الشكر للزوار',
                  '90 يومًا افتراضيًا. ويمكن لشركتك تحديد 30 إلى 365 يومًا',
                ],
                [
                  'الرسائل والملفات',
                  '730 يومًا افتراضيًا. ويمكن لشركتك تحديد 30 إلى 3,650 يومًا',
                ],
                [
                  'محادثات الاجتماعات',
                  'تُغلق بعد يوم من الاجتماع، ويمكن للمنظم حذفها حينئذ، وتُحذف المحادثة التي لم يكتب فيها أحد. وإلا فتُنقل إلى الأرشيف بعد 30 يومًا من الاجتماع افتراضيًا (ويمكن لشركتك تحديد 1 إلى 365 يومًا)، ثم تُحذف مع الرسائل الأخرى',
                ],
                [
                  'رموز الدخول لمرة واحدة',
                  '10 دقائق، وتُحفظ في صورة قيمة تجزئة فقط',
                ],
                [
                  'سجلات الحد من إساءة الاستخدام',
                  'تُحذف بعد انتهاء صلاحيتها بوقت قصير',
                ],
                [
                  'جلسات الدخول، مع عنوان IP ونوع المتصفح',
                  'إلى أن تسجل الخروج، أو تسجل الخروج من جميع الأجهزة، أو يُحذف حسابك',
                ],
                [
                  'السجلات التقنية لدى مزودي الاستضافة، وفيها عناوين IP',
                  'حتى 7 أيام',
                ],
                [
                  'الحجوزات، وملاحظات تغيير الموعد، وسجل الاجتماعات، ونشاط الشركة',
                  'ما دامت شركتك تستخدم MeetNPlan. ويمكن للمسؤولين مسح الحجوزات السابقة. وتُحذف مع حذف الشركة',
                ],
                ['الإشعارات', 'سنة واحدة'],
                [
                  'سجلات البريد المرسل إلى الضيوف',
                  '90 يومًا، أو إلى انقضاء الاجتماع إن كان ذلك لاحقًا',
                ],
                ['طلبات الدعم', '3 سنوات من إغلاق الطلب'],
                ['من تقدموا للانضمام ورُفضوا ولم يُقبلوا قط', '90 يومًا من رفضهم'],
                [
                  'طلب الضيف إيقاف رسائل شركة ما',
                  'ما دامت تلك الشركة تستخدم MeetNPlan، ليظل الطلب ساريًا، ويُحذف مع حذف الشركة',
                ],
                [
                  'حسابك',
                  'إلى أن تحذفه أو تزيلك شركتك. عندها تُحذف بيانات دخولك وحجوزاتك وإشعاراتك ودعواتك. وتبقى الرسائل التي أرسلتها والسجلات السابقة إلى انتهاء مدتها',
                ],
                [
                  'الشركة التي تحذف مؤسستها',
                  'يمكن استعادتها خلال 30 يومًا، ثم تُحذف بياناتها وملفاتها وحسابات الدخول',
                ],
                [
                  'سجل الشركة المغلقة: الاسم، والنطاقات، وإجمالي المدفوعات، ومن حذفها',
                  '10 سنوات، ثم يُمحى الاسم والنطاقات والمبالغ. ويبقى معرّف الشركة حتى لا يُمنح لغيرها',
                ],
                ['سجلات التدقيق', 'سنتان، وتبقى بعد إغلاق الشركة'],
                [
                  'سجل التجربة المجانية: مفتاح التجربة، واسم الشركة، وبريد المؤسس ومعرّفه',
                  '3 سنوات، لمنع تكرار التجربة المجانية',
                ],
                [
                  'مساحة عمل انتهى اشتراكها',
                  'تبقى للقراءة فقط مع بياناتها إلى أن تحذفها الشركة. ونحذفها بعد 12 شهرًا من انتهاء الاشتراك، بعد إشعار مسؤوليها قبل 30 يومًا. ولا تنتهي الباقة المجانية التي ليس لها تاريخ انتهاء',
                ],
                [
                  'الفواتير وسجلات الدفع',
                  '10 سنوات، حتى بعد إغلاق الشركة. ولا يمكن حذفها عند الطلب، لأن النظام يوجب علينا الاحتفاظ بها',
                ],
                [
                  'سجلات إصدارات الشروط وسياسة الخصوصية التي قبلتها',
                  '10 سنوات، وأكثر ما دام ذلك الإصدار ساريًا',
                ],
                ['النسخ الاحتياطية', 'حتى 7 أيام، ثم يُكتب فوقها'],
              ],
            },
          },
          'عند انتهاء المدة، نتلف البيانات أو نخفي هوية أصحابها، ما لم يوجب النظام الاحتفاظ بها. ولا يؤدي حذف السجل إلى استرجاع الرسائل المرسلة.',
        ],
      },
      {
        id: 'your-rights',
        title: 'حقوقك',
        body: [
          'بموجب نظام حماية البيانات الشخصية، يحق لك:',
          {
            list: [
              'العلم بكيفية جمع بياناتك واستخدامها وسبب ذلك ومسوغه النظامي؛',
              'الوصول إلى بياناتك وطلب الحصول على نسخة منها بصيغة واضحة ومقروءة؛',
              'طلب تصحيح بياناتك أو إتمامها أو تحديثها، وتقييد معالجتها أثناء التحقق منها؛',
              'طلب إتلاف بياناتك عند انتهاء الحاجة إليها، مع مراعاة البند 9 وما يوجب النظام الاحتفاظ به؛',
              'الرجوع عن موافقتك في أي وقت بمراسلتنا، دون أن يؤثر ذلك فيما تم قبل الرجوع؛',
              'تقديم شكوى إلى الجهة المختصة، والمطالبة بالتعويض عن الضرر وفق النظام.',
            ],
          },
        ],
      },
      {
        id: 'how-to-use-your-rights',
        title: 'كيف تمارس حقوقك',
        body: [
          {
            lead: 'من التطبيق.',
            text: 'يمكنك من ملفك الشخصي تغيير رقم الجوال، والصورة، واللغة، وكلمة المرور، وخيارات الإشعارات واختيارك بشأن أخبار المنتج، وتنزيل نسخة من بياناتك، وتسجيل الخروج من جميع الأجهزة، وفصل تقويم Google، وحذف حسابك. وعلى المؤسس أولًا تسليم الدور إلى مسؤول آخر، ولا يملك المؤسس المنفرد إلا حذف مساحة العمل. وعلى آخر مسؤول أولًا تعيين مسؤول آخر. ولتصحيح اسمك أو بريدك، راسلنا.',
          },
          {
            lead: 'بالبريد الإلكتروني.',
            text: 'راسلنا على العنوان الوارد في البند 1، والخدمة مجانية. وقد نطلب منك تأكيد هويتك. وننفذ طلبك خلال 30 يومًا، أو خلال مدة إضافية لا تتجاوز 30 يومًا إذا تطلب الطلب جهدًا غير متناسب أو تعددت طلباتك، ونبلغك بالسبب مسبقًا. وتغطي النسخة المتاحة من ملفك الشخصي عبر "تنزيل بياناتي" ما نحتفظ به تحت بريدك الإلكتروني، بما في ذلك جلسات دخولك. وتذكر أسماء ملفاتك وما إذا كان لك توقيع محفوظ دون نسخهما، ولا تشمل نشاط الشركة وسجلات التدقيق. ولغير ذلك نُعدّ نسخة عند الطلب.',
          },
          {
            lead: 'الموظفون والضيوف والزوار.',
            text: 'إذا كان طلبك يتعلق بسجلات تتحكم فيها شركتك، فنرجو التوجه إليها أولًا. وإن راسلتنا، فسنحيل طلبك إليها ونساعدها في الرد عليه.',
          },
        ],
      },
      {
        id: 'how-we-protect-it',
        title: 'كيف نحميها',
        body: [
          'الاتصالات مشفرة أثناء النقل. وتُحفظ كلمات المرور في صورة قيم تجزئة. وتدوم رموز الدخول 15 دقيقة قبل تجديدها. ويُقيَّد الوصول بحسب الدور وبقواعد قاعدة البيانات، فلا تستطيع شركة قراءة سجلات شركة أخرى. وتُحفظ الملفات في تخزين خاص. وتُحفظ رموز إذن تقويم Google مشفرة. ويسجل مشغّلونا دخولهم بكلمة مرور وتطبيق مصادقة. والرسائل غير مشفرة من طرف إلى طرف. ولا يوجد نظام آمن تمامًا، فنرجو الحفاظ على سرية كلمة مرورك.',
        ],
      },
      {
        id: 'if-something-goes-wrong',
        title: 'إذا حدث خلل',
        body: [
          'حيثما كنا جهة التحكم، نبلغ الهيئة السعودية للبيانات والذكاء الاصطناعي (سدايا) خلال 72 ساعة من علمنا بأي تسرب قد يلحق ضررًا ببياناتك أو بك، أو يتعارض مع حقوقك أو مصالحك، ونبلغك دون تأخير غير مبرر بما حدث وبما يمكنك فعله. أما البيانات التي تتحكم فيها شركتك، فنبلغ شركتك دون تأخير غير مبرر، وهي التي تتولى تلك الإشعارات.',
        ],
      },
      {
        id: 'automated-decisions',
        title: 'القرارات الآلية',
        body: [
          'لا نتخذ بشأنك قرارات مبنية بشكل كامل على المعالجة الآلية لها أثر نظامي أو أثر مماثل. وتعمل بعض القواعد البسيطة تلقائيًا، فيُرفض طلب الحجز ذو الأولوية إذا لم يرد عليه أحد خلال 20 دقيقة، ويمكن إلغاء حجز القاعة التي لم يحضر إليها أحد إذا فعّلت شركتك ذلك. ويُرفض طلب حجز القاعة الذي لم يعتمده أحد عند حلول موعد بدء الاجتماع.',
        ],
      },
      {
        id: 'messages-from-us',
        title: 'رسائلنا إليك',
        body: [
          'نرسل الرسائل التي تتطلبها الخدمة، كالدعوات، والتذكيرات، وإشعارات الفوترة، والتنبيهات الأمنية. ويمكنك إدارة كثير منها من ملفك الشخصي، لكننا نواصل إرسال ما يتعلق بأمن حسابك وفوترته. ولا نرسل الأخبار والعروض إلا بموافقتك المستقلة، وتوضح كل رسالة مرسلها وتتضمن رابطًا لإيقافها بنقرة واحدة مجانًا. وتتضمن كل رسالة اجتماع تُرسل إلى ضيف رابطًا لإيقاف رسائل تلك الشركة إلى بريده. وإذا أرسل المضيف بعد ذلك رسالة إلى ذلك الضيف من MeetNPlan، يُبلغه التطبيق بأنها لم تُرسل.',
        ],
      },
      {
        id: 'under-18',
        title: 'من هم دون 18 عامًا',
        body: [
          'MeetNPlan مخصصة للبالغين في بيئة العمل، والحسابات لمن بلغ 18 عامًا فأكثر. وإذا كان الزائر دون 18 عامًا، فإن الشركة التي تستقبله مسؤولة عن أي موافقة من الولي الشرعي يوجبها النظام.',
        ],
      },
      {
        id: 'cookies-and-browser-storage',
        title: 'ملفات تعريف الارتباط وتخزين المتصفح',
        body: ['راجع سياسة ملفات تعريف الارتباط لدينا.'],
      },
      {
        id: 'changes-to-this-policy',
        title: 'تعديل هذه السياسة',
        body: [
          'ننشر التعديلات هنا مع رقم إصدار وتاريخ جديدين. ونبلغ أصحاب الحسابات قبل سريان أي تغيير مهم.',
          {
            table: {
              head: ['الإصدار', 'التاريخ', 'التغيير'],
              rows: [
                [
                  '1.0',
                  '4 نوفمبر 2026',
                  'الإصدار الأول بموجب نظام حماية البيانات الشخصية',
                ],
              ],
            },
          },
        ],
      },
      {
        id: 'contact-and-complaints',
        title: 'التواصل والشكاوى',
        body: [
          'نرجو مراسلتنا أولًا على العنوان الوارد في البند 1. ويمكنك تقديم شكوى إلى الهيئة السعودية للبيانات والذكاء الاصطناعي (سدايا)، عبر sdaia.gov.sa، خلال 90 يومًا من وقوع الحدث أو من علمك به. ويجوز لسدايا قبول الشكاوى المتأخرة لسبب وجيه.',
        ],
      },
    ],
  },
  {
    path: '/terms',
    title: 'شروط الخدمة',
    intro:
      'الاتفاق بين MeetNPlan والشركات التي تستخدمها. عند اختلاف النسختين العربية والإنجليزية، تسود النسخة العربية.',
    sections: [
      {
        id: 'who-we-are',
        title: 'من نحن',
        body: [
          'تقدم MeetNPlan شركة Code LTD، سجل تجاري رقم 7025667853، والرقم الضريبي 311024246500003، وعنوانها طريق الأمير سلطان بن عبدالعزيز، حي السليمانية، الرياض 12232، المملكة العربية السعودية ("نحن"). للتواصل: hello@meetnplan.co أو 800 100 0018.',
        ],
      },
      {
        id: 'this-agreement',
        title: 'هذا الاتفاق',
        body: [
          'هذه الشروط اتفاق بيننا وبين الشركة التي تستخدم MeetNPlan ("العميل"). وتقبلها نيابة عن العميل بالتأشير على المربع المخصص لذلك عند إنشاء مساحة عمل أو تقديم طلب شراء. وإذا قبلتها نيابة عن شركة، فأنت تؤكد أنك مفوض بإلزامها. وعلى العميل ضمان التزام مستخدميه بالبندين 5 و6. ولا تُلزم هذه الشروط الضيوف أو الزوار.',
        ],
      },
      {
        id: 'the-service',
        title: 'الخدمة',
        body: [
          'MeetNPlan برنامج يعمل عبر الإنترنت لحجز الاجتماعات والقاعات، ودعوة الضيوف، وتسجيل دخول الزوار عند الاستقبال، والمراسلة داخل الشركة، والمزامنة مع تقويم Google. ويتوقف ما تحصل عليه على باقتك كما هو موضح في طلبك وحسابك. ونقدم الخدمة عبر الإنترنت، فلا يُسلَّم أي منتج مادي.',
        ],
      },
      {
        id: 'who-may-use-it',
        title: 'من يحق له استخدامها',
        body: [
          'يجب ألا يقل عمر المستخدم عن 18 عامًا. وMeetNPlan مخصصة للشركات والمنشآت. ولا يجوز للجهات الحكومية، ولا لمن يحتفظ ببيانات حكومية، استخدامها ما دامت مستضافة خارج المملكة.',
        ],
      },
      {
        id: 'accounts',
        title: 'الحسابات',
        body: [
          'ينضم الأشخاص إلى مساحة العمل عبر نطاق البريد الإلكتروني للشركة، أو رمز الشركة، أو دعوة، أو رابط، ويعتمد المسؤول أو الموارد البشرية كل عضو جديد. ويدير العميل أعضاءه وأدوارهم، وهو مسؤول عما يتم عبر حساباته. فاحرص على سرية بيانات دخولك، وأبلغنا فورًا إذا اشتبهت في إساءة استخدام أي حساب. ويمكن لمؤسس مساحة العمل تسليم هذا الدور إلى مسؤول آخر.',
        ],
      },
      {
        id: 'acceptable-use',
        title: 'الاستخدام المقبول',
        body: [
          'يجب عليك استخدام الخدمة وفق الأنظمة، ويجب ألا:',
          {
            list: [
              'تحاول الوصول إلى بيانات أو حسابات لا يحق لك الاطلاع عليها؛',
              'تهاجم الخدمة أو تثقلها أو تختبرها أو تعطلها، أو تتجاوز حدودها؛',
              'تنسخها أو تعيد بيعها أو تُجري هندسة عكسية لها، إلا بالقدر الذي يجيزه النظام؛',
              'ترسل رسائل مزعجة، أو أي محتوى مخالف للأنظمة، أو ضار، أو مخل بالنظام العام؛',
              'تحفظ فيها نسخًا من بطاقات الهوية أو غيرها من الوثائق الرسمية، أو ترفع إليها بيانات حساسة لم تُصمَّم لها.',
            ],
          },
        ],
      },
      {
        id: 'customer-data',
        title: 'بيانات العميل',
        body: [
          'يملك العميل البيانات التي يدخلها في MeetNPlan. ولا نستخدمها إلا لتقديم الخدمة وحمايتها، على النحو المبين في هذه الشروط وفي سياسة الخصوصية. والعميل مسؤول عن توفر مسوغ نظامي لتلك البيانات، وعن إبلاغ موظفيه وضيوفه وزواره بكيفية استخدامها.',
        ],
      },
      {
        id: 'data-processing',
        title: 'معالجة البيانات',
        body: [
          'بالنسبة إلى البيانات الشخصية التي يتحكم فيها العميل، يكون العميل جهة التحكم ونكون نحن جهة المعالجة لمصلحته. ونعالج الفئات الواردة في البند 3 من سياسة الخصوصية طوال مدة هذا الاتفاق وخلال المدد الواردة في البند 16. ونلتزم بما يلي:',
          {
            list: [
              'عدم معالجتها إلا وفق تعليمات العميل، المتمثلة في هذه الشروط وفي استخدامه الخدمة، ما لم يوجب النظام خلاف ذلك؛',
              'الحفاظ على سريتها، وقصر الوصول إليها على من يحتاج إليه؛',
              'تطبيق الإجراءات والوسائل التنظيمية والتقنية المناسبة لأمنها؛',
              'إبلاغ العميل كتابيًا بأي مخالفة لتعليماته أو للأنظمة السعودية؛',
              'عدم الاستعانة إلا بجهات المعالجة الفرعية الواردة في سياسة الخصوصية، التي يقبلها العميل، على أن تلتزم كل منها بحماية مماثلة. ونبلغ العميل قبل 30 يومًا من إضافة أي منها أو تغييرها، ويجوز له الاعتراض خلال 14 يومًا. وإذا تعذر حل الاعتراض، جاز للعميل إنهاء الخدمة المتأثرة واسترداد الرسوم المدفوعة مقدمًا عن المدة غير المستخدمة؛',
              'إبلاغ العميل بأن Supabase وCloudflare وResend وGoogle شركات أمريكية، فقد يلزمها النظام الأمريكي بالإفصاح عن البيانات؛',
              'إبلاغ العميل بأي إفصاح يوجبه نظام أو جهة مختصة، متى جاز لنا ذلك نظامًا. ولا تتطلب هذه الإفصاحات موافقة أصحاب البيانات الشخصية؛',
              'إبلاغ العميل دون تأخير غير مبرر بأي تسرب للبيانات الشخصية، ليتمكن من الوفاء بالتزاماته؛',
              'مساعدة العميل في الرد على أصحاب البيانات الشخصية وعلى الهيئة السعودية للبيانات والذكاء الاصطناعي (سدايا)؛',
              'إتلاف البيانات على النحو المبين في البند 16، ما لم يوجب النظام الاحتفاظ بها؛',
              'تزويد العميل بالمعلومات التي يحتاج إليها بشكل معقول للتحقق من وفائنا بهذه الالتزامات، وتمكينه أو جهة تقييم مستقلة من التحقق.',
            ],
          },
          'يوجّهنا العميل، نيابة عنه، إلى معالجة البيانات خارج المملكة على النحو المبين في سياسة الخصوصية.',
        ],
      },
      {
        id: 'free-plans-and-trials',
        title: 'الباقات المجانية والتجارب',
        body: [
          'تستمر الباقة المجانية أو التجربة للمدة الموضحة في حسابك. ويحق لكل نطاق بريد إلكتروني لشركة أو بريد شخصي تجربة مجانية واحدة. وعند انتهائها تصبح مساحة العمل للقراءة فقط، ولا يُفرض عليك أي مبلغ. وتستمر الباقة المجانية المعروضة دون تاريخ انتهاء إلى أن نشعرك بإنهائها قبل 60 يومًا على الأقل.',
        ],
      },
      {
        id: 'paid-plans-and-prices',
        title: 'الباقات المدفوعة والأسعار',
        body: [
          'تُفوتر الباقات المدفوعة شهريًا أو سنويًا. ويُعرض السعر، وأي إضافات، وضريبة القيمة المضافة، والإجمالي قبل الدفع. ونضيف ضريبة القيمة المضافة بالنسبة السارية، وهي حاليًا 15%، ونرسل فاتورة عن كل دفعة. وتدفع بالتحويل البنكي أو بوسيلة أخرى نتفق عليها، أو بالبطاقة أو STC Pay عبر مزود الدفع لدينا متى أتاح التطبيق ذلك. ويُبرم عقد الباقة المدفوعة وتبدأ باقتك عند تأكيدنا الدفع.',
          {
            lead: 'التجديد.',
            text: 'لا تتجدد باقتك إلا عند دفع الفترة التالية. ونذكّرك قبل انتهائها بسبعة أيام وثلاثة أيام ويوم واحد. ولا يسري التجديد التلقائي إلا إذا عرضناه واخترته عند الدفع.',
          },
          {
            lead: 'تغيير الأسعار.',
            text: 'نقدم إشعارًا قبل 30 يومًا على الأقل من سريان أي سعر جديد. ويسري من تجديدك التالي، ولا يسري أبدًا على فترة دفعت مقابلها.',
          },
        ],
      },
      {
        id: 'late-payment',
        title: 'تأخر السداد',
        body: [
          'إذا انتهت الفترة دون سداد، تحصل على مهلة 7 أيام مع إمكانية الوصول الكامل. ثم تصبح مساحة العمل للقراءة فقط، مع بقاء بياناتك، إلى أن تسدد. ولا نفرض أي فائدة أو غرامة على التأخر في السداد.',
        ],
      },
      {
        id: 'cancelling-and-refunds',
        title: 'الإلغاء والاسترداد',
        body: [
          {
            lead: 'حقك في فسخ العقد.',
            text: 'يجوز لك فسخ العقد خلال 7 أيام من تاريخ إبرامه واسترداد المبلغ كاملًا، ما لم يستخدم أحد الأعضاء ميزة مدفوعة، لأنك تكون عندئذ قد استفدت من الخدمة. وإذا تأخرنا في بدء باقتك أكثر من 15 يومًا، في غير حالات القوة القاهرة، جاز لك فسخ العقد واسترداد ما دفعته وتكاليف التأخير.',
          },
          {
            lead: 'الإلغاء لاحقًا.',
            text: 'يمكنك الإلغاء في أي وقت من صفحة الفوترة. وتستمر باقتك عندئذ إلى نهاية الفترة المدفوعة ثم تتوقف، ويمكنك التراجع عن ذلك حتى ذلك الحين. وإذا اخترت الإيقاف الفوري، تصبح مساحة العمل للقراءة فقط في الحال ولا تُسترد قيمة الفترة المتبقية.',
          },
          {
            lead: 'تغيير الباقة.',
            text: 'تبدأ الباقة الجديدة عند تأكيد دفعها، وتُحتسب قيمة الأيام غير المستخدمة من الباقة السابقة رصيدًا من سعرها. وإذا زادت قيمة هذا الرصيد على أول دفعة للباقة الجديدة، نرتّب التغيير معك. ويسري تخفيض الإضافات من تجديدك التالي.',
          },
          'ونرد المبالغ كذلك في الحالات التي تنص عليها هذه الشروط أو النظام، أو إذا حصّلنا منك مبلغًا بالخطأ. وتُرد المبالغ إلى وسيلة الدفع الأصلية متى أمكن.',
        ],
      },
      {
        id: 'availability-and-support',
        title: 'التوفر والدعم',
        body: [
          'نعمل على إبقاء MeetNPlan متاحة، ولا نضمن أن تعمل دون انقطاع أو أخطاء. وقد نجري أعمال صيانة، ونسعى إلى الإشعار بالأعمال المخطط لها. ويُقدَّم الدعم عبر الطلبات للمسؤولين وعبر البريد الإلكتروني للجميع. ونستهدف الرد الأول خلال 24 ساعة، أو 4 ساعات في الدعم ذي الأولوية. وهذه أهداف وليست ضمانات.',
        ],
      },
      {
        id: 'changes-to-the-service',
        title: 'تغيير الخدمة',
        body: [
          'قد نحسّن المزايا أو نغيرها. وإذا كان التغيير يقلل بشكل جوهري مما دفعت مقابله، فسنبلغك مسبقًا، ويجوز لك إنهاء الباقة المتأثرة واسترداد الرسوم المدفوعة مقدمًا عن المدة غير المستخدمة.',
        ],
      },
      {
        id: 'other-services',
        title: 'الخدمات الأخرى',
        body: [
          'تسجيل الدخول عبر Google وتقويم Google اختياريان ويخضعان لشروط Google. ولسنا مسؤولين عن خدمات لا نشغّلها، ولا يحد ذلك من التزاماتنا تجاهك فيما يخص الجزء الذي نقدمه.',
        ],
      },
      {
        id: 'ending-the-agreement-and-your-data',
        title: 'إنهاء الاتفاق وبياناتك',
        body: [
          {
            lead: 'من جانبك.',
            text: 'يمكنك التوقف عن استخدام الخدمة والإلغاء في أي وقت. ولحذف مساحة عمل، يجب على المؤسس أولًا إزالة جميع الأعضاء الآخرين وإلغاء أي اشتراك قائم. ويمكنك استعادة مساحة العمل المحذوفة خلال 30 يومًا. وبعد ذلك تُحذف بياناتها وملفاتها وحسابات الدخول، باستثناء ما يوجب النظام الاحتفاظ به وسجلات الشركات المغلقة والتجارب المجانية والتدقيق المبينة في سياسة الخصوصية. ويمكنك أن تطلب منا نسخة من بياناتك قبل ذلك.',
          },
          {
            lead: 'من جانبنا.',
            text: 'إذا أخللت بهذه الشروط إخلالًا جسيمًا، فسنبلغك ونمنحك 14 يومًا لتداركه، ويجوز لنا فسخ الاتفاق دون حكم قضائي إذا لم تفعل. وتوافق على أنه يجوز لنا إيقاف الوصول فورًا، دون حكم قضائي أو إشعار إضافي، في الحالات التي يلزم فيها ذلك فقط لوقف تهديد أمني أو استخدام غير نظامي أو ضرر جسيم. وسنبلغك بالسبب في أقرب وقت ممكن.',
          },
        ],
      },
      {
        id: 'intellectual-property',
        title: 'الملكية الفكرية',
        body: [
          'نملك MeetNPlan وبرامجها وتصميمها وعلامتها التجارية. ولك حق محدود في استخدامها خلال مدة الاتفاق. وإذا أرسلت إلينا ملاحظات، جاز لنا استخدامها بحرية.',
        ],
      },
      {
        id: 'confidentiality',
        title: 'السرية',
        body: [
          'يحافظ كل طرف على سرية المعلومات غير العلنية للطرف الآخر، ولا يستخدمها إلا لأغراض هذا الاتفاق، ما لم يوجب النظام الإفصاح عنها.',
        ],
      },
      {
        id: 'warranties',
        title: 'الضمانات',
        body: [
          'نقدم الخدمة بالمهارة والعناية المعقولتين. وفيما عدا ذلك وما يوجبه النظام، لا نقدم أي تعهد آخر بملاءمتها لغرض معين.',
        ],
      },
      {
        id: 'liability',
        title: 'المسؤولية',
        body: [
          'يتحمل كل طرف مسؤولية الضرر الذي يمكن توقعه ويتسبب فيه بالإخلال بهذا الاتفاق. ويقتصر إجمالي مسؤوليتنا عن جميع المطالبات خلال أي 12 شهرًا على الرسوم التي دفعها العميل لنا خلال تلك الأشهر الاثني عشر، أو 1,000 ريال سعودي إذا لم يدفع شيئًا. ويسري هذا الحد على عدم تنفيذ هذا الاتفاق أو التأخر في تنفيذه.',
          'ليس في هذه الشروط ما يحدّ من المسؤولية عن الغش أو الخطأ الجسيم أو الفعل الضار أو يعفي منها، ولا ما يحدّ من أي مسؤولية أو حق لا يجيز النظام الحد منه.',
        ],
      },
      {
        id: 'events-beyond-control',
        title: 'القوة القاهرة',
        body: [
          'لا يُسأل أي طرف عن عدم التنفيذ بسبب حدث لا يد له فيه لم يكن بالإمكان توقعه أو تفاديه. وإذا استمر أكثر من 30 يومًا، جاز لأي طرف إنهاء الباقة المتأثرة، ونرد الرسوم المدفوعة مقدمًا عن المدة غير المستخدمة. وتُحتسب رصيدًا رسوم فترات عدم توفر الخدمة.',
        ],
      },
      {
        id: 'changes-to-these-terms',
        title: 'تعديل هذه الشروط',
        body: [
          'نقدم إشعارًا قبل 30 يومًا على الأقل من سريان أي تعديل، بالبريد الإلكتروني أو داخل التطبيق، ما لم يوجب نظام سريانه قبل ذلك. وإذا لم توافق، جاز لك إنهاء الاتفاق قبل سريان التعديل، ونرد الرسوم المدفوعة مقدمًا عن المدة غير المستخدمة. واستمرارك في استخدام الخدمة بعد ذلك التاريخ يعد قبولًا للتعديل.',
        ],
      },
      {
        id: 'complaints',
        title: 'الشكاوى',
        body: [
          'أرسل الشكاوى إلى العنوان الوارد في البند 1. ونرد خلال 10 أيام عمل. ويمكنك كذلك تقديم شكوى إلى وزارة التجارة.',
        ],
      },
      {
        id: 'law-and-disputes',
        title: 'النظام وتسوية المنازعات',
        body: [
          'تخضع هذه الشروط لأنظمة المملكة العربية السعودية. ويسعى الطرفان أولًا إلى تسوية أي نزاع وديًا خلال 30 يومًا. فإن تعذر ذلك، تفصل فيه المحاكم المختصة في الرياض. ويجوز لأي طرف تقديم الطلبات المستعجلة إليها في أي وقت.',
        ],
      },
      {
        id: 'general',
        title: 'أحكام عامة',
        body: [
          'تسود النسخة العربية على أي ترجمة. ونرسل الإشعارات بالبريد الإلكتروني أو داخل التطبيق. وإذا بطل جزء من هذه الشروط، بقي الباقي نافذًا. ولا يجوز لأي طرف نقل هذا الاتفاق دون موافقة الطرف الآخر، إلا إلى خلف لنشاطه التجاري مع الإشعار بذلك. وتظل البنود المتعلقة بالسرية والمسؤولية والمنازعات والبيانات سارية بعد انتهاء الاتفاق.',
        ],
      },
    ],
  },
  {
    path: '/cookies',
    title: 'سياسة ملفات تعريف الارتباط',
    intro:
      'ما يحفظه MeetNPlan في متصفحك، ولماذا. عند اختلاف النسختين العربية والإنجليزية، تسود النسخة العربية.',
    sections: [
      {
        id: 'the-short-version',
        title: 'باختصار',
        body: [
          'لا نستخدم ملفات تعريف ارتباط إعلانية، ولا نتتبعك عبر المواقع الأخرى. ولا يُنشئ برنامجنا أي ملفات تعريف ارتباط، بل يحفظ إعدادات صغيرة في تخزين متصفحك. وقد يُنشئ بعض مزودينا ملفات تعريف ارتباط خاصة بهم لأغراض الأمن أو لتسجيل الدخول عبر Google. وتشمل هذه السياسة meetnplan.co وapp.meetnplan.co.',
        ],
      },
      {
        id: 'what-these-things-are',
        title: 'ما المقصود بها',
        body: [
          'ملف تعريف الارتباط ملف صغير يحفظه الموقع في متصفحك. ويؤدي تخزين المتصفح دورًا مشابهًا: فتخزين الجلسة يُمسح عند إغلاق علامة التبويب، والتخزين المحلي يبقى إلى أن تمسحه أنت أو الموقع.',
        ],
      },
      {
        id: 'our-website-meetnplan-co',
        title: 'موقعنا meetnplan.co',
        body: [
          {
            table: {
              head: ['الاسم', 'النوع', 'السبب', 'المدة'],
              rows: [
                [
                  'locale',
                  'تخزين محلي',
                  'تذكّر اللغة العربية أو الإنجليزية',
                  'إلى أن تمسحه',
                ],
              ],
            },
          },
        ],
      },
      {
        id: 'the-app-app-meetnplan-co',
        title: 'التطبيق app.meetnplan.co',
        body: [
          'كل ما يلي لازم لعمل التطبيق أو لحفظ خيار اخترته، ولا يُستخدم أي منها في الإعلانات.',
          {
            table: {
              head: ['الغرض', 'الأسماء', 'المدة'],
              rows: [
                [
                  'إبقاؤك مسجلًا الدخول',
                  'mnp-auth-customer، mnp-auth-platform',
                  'إلى إغلاق علامة التبويب، أو مع خيار "تذكرني" إلى أن تسجل الخروج. أما mnp-auth-platform، لوحة مشغّلينا، فلعلامة التبويب فقط دائمًا',
                ],
                [
                  '"تذكرني" والحسابات الأخيرة: بريدك وما يصل إلى خمسة عناوين حديثة وأسماء شركاتها على هذا الجهاز',
                  'mnp_remember، mnp_remembered_email، mnp_known_accounts',
                  'تخزين محلي. ويُحذف بريدك والحسابات الأخيرة عند إلغاء خيار "تذكرني"، ويحفظ mnp_remember هذا الاختيار. وتُهمل الحسابات الأخيرة بعد 30 يومًا',
                ],
                [
                  'اللغة ونمط التاريخ',
                  'mnp_lang، mnp_datesys، mnp_lang_chosen، mnp_lang_cover',
                  'تخزين محلي لاختيارك، وعلامة التبويب فقط للبقية',
                ],
                [
                  'العمل غير المرسل: مسودات الاجتماعات والرسائل والإشعارات',
                  'mnp:schedule-draft:*، mnp:chat-draft:*، mnp:chat-outbox:*، mnp:notice-draft:*، mnp_signup_draft',
                  'علامة التبويب فقط، إلى الإرسال أو الإغلاق. وتبقى مسودات الإشعارات في التخزين المحلي إلى الإرسال أو تسجيل الخروج',
                ],
                [
                  'الإشعارات التي شاهدتها',
                  'mnp_dismissed_announcements، mnp:popups:seen:*، mnp:popups:hidden، mnp:desk:snooze',
                  'تخزين محلي أو علامة التبويب فقط',
                ],
                [
                  'توجيهك إلى المكان الصحيح أثناء الدخول والإعداد',
                  'mnp_auth_landing، mnp_auth_bounce، mnp_founding_intent، pendingInvite، pendingPriority، mnp_setup_*، mnp_member_arrival، mnp_chunk_reload',
                  'علامة التبويب فقط',
                ],
              ],
            },
          },
        ],
      },
      {
        id: 'other-companies',
        title: 'الشركات الأخرى',
        body: [
          {
            table: {
              head: ['المزود', 'ما يحدث', 'السبب'],
              rows: [
                [
                  'Cloudflare',
                  'قد ينشئ __cf_bm أو cf_clearance. وتُجري خدمة Turnstile فحصًا على صفحات الدخول. كما يجمع تقارير أخطاء الشبكة في الموقعين، دون إنشاء ملفات تعريف ارتباط',
                  'الأمن والموثوقية',
                ],
                [
                  'Google',
                  'يستخدم تسجيل الدخول عبر Google ملفات تعريف ارتباط خاصة بها على نطاقاتها، إن اخترته. وقد يحفظ برنامجه ملف تعريف ارتباط باسم g_state على app.meetnplan.co، ليتذكر أنك سجلت الخروج أو أغلقت نافذته. وتُحمَّل الخطوط من Google في الموقعين، فتتلقى Google عنوان IP الخاص بك',
                  'تسجيل الدخول والخطوط',
                ],
                [
                  'Moyasar',
                  'قد تنشئ صفحات الدفع وأمان البنك ملفات تعريف ارتباط خاصة بها عند الدفع',
                  'تحصيل المدفوعات بأمان',
                ],
              ],
            },
          },
        ],
      },
      {
        id: 'your-choices',
        title: 'خياراتك',
        body: [
          'يمكنك مسح ملفات تعريف الارتباط وتخزين المتصفح أو حظرها من إعدادات متصفحك. وإذا حظرت ما يحتاج إليه التطبيق، فقد لا تتمكن من تسجيل الدخول. ويزيل تسجيل الخروج جلستك من هذا المتصفح، ويبقى بريدك المحفوظ وحساباتك الأخيرة إلى أن تلغي خيار "تذكرني". ولا نطلب موافقتك على ملفات تعريف الارتباط، لأن هذه العناصر لا تفعل إلا تشغيل الخدمة التي طلبتها. وإذا أضفنا يومًا إعلانات أو تتبعًا عبر المواقع، فسنطلب موافقتك أولًا.',
        ],
      },
      {
        id: 'changes-and-contact',
        title: 'التغييرات والتواصل',
        body: [
          'نحدّث هذه الصفحة عند تغير هذه العناصر. وتُوجَّه الأسئلة إلى العنوان الوارد في سياسة الخصوصية.',
        ],
      },
    ],
  },
]
